<template>
  <div class="side-bg">
    <Menu
      ref="menu"
      class="i-layout-menu-side i-scrollbar-hide"
      :class="{ 'i-layout-menu-side-collapse': menuCollapse }"
      :theme="siderTheme"
      :accordion="menuAccordion"
      :active-name="activePath"
      :open-names="openNames"
      @on-open-change="handleOpenNameChange"
      width="auto"
    >
      <template v-for="(item, index) in filteredSider">
        <template v-if="!menuCollapse && item.enable == 1">
          <IMenuSideItem
            v-if="!item.children || !item.children.length"
            :menu="item"
            :key="index"
          />
          <IMenuSideSubmenu v-else :menu="item" :key="index" />
        </template>
        <template v-else-if="item.enable == 1">
          <Tooltip
            v-if="!item.children || !item.children.length"
            :content="tTitle(item.title)"
            placement="right"
            :key="index"
          >
            <IMenuSideItem :menu="item" hide-title />
          </Tooltip>
          <IMenuSideCollapse v-else :menu="item" top-level :key="index" />
        </template>
      </template>
    </Menu>
  </div>
</template>

<script>
import IMenuSideItem from "./menu-item";
import IMenuSideSubmenu from "./submenu";
import IMenuSideCollapse from "./menu-collapse";
import tTitle from "../mixins/translate-title";
import {
  getHeaderName,
  getMenuSider,
  getSiderSubmenu,
  getSiderOpenNames,
} from "@/libs/ab-system";
import { mapState, mapGetters } from "vuex";

// 判断元素是否在可视区域
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export default {
  name: "IMenuSide",
  mixins: [tTitle],
  components: { IMenuSideItem, IMenuSideSubmenu, IMenuSideCollapse },
  props: {
    hideLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      smalllogo: "",
      xclogo: "",
    };
  },
  created() {
    const systemConfigInfos = JSON.parse(
      localStorage.getItem("systemConfigInfos")
    );
    this.smalllogo = systemConfigInfos.logo_small;
    this.xclogo = systemConfigInfos.xc_logo;
  },
  computed: {
    ...mapState("admin/layout", [
      "siderTheme",
      "menuAccordion",
      "menuCollapse",
    ]),
    ...mapState("admin/menu", ["activePath", "openNames"]),
    ...mapGetters("admin/menu", ["filterSider"]),
    filteredSider() {
      return this.filterSider.filter((item) => item.enable === 1);
    },
  },
  watch: {
    $route: {
      handler() {
        this.updateMenuState();
      },
      immediate: true,
    },
    // 在展开/收起侧边菜单栏时，更新一次 menu 的状态
    menuCollapse() {
      this.updateMenuStateOnCollapse();
      this.updateMenuState();
    },
    openNames() {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();
        this.$refs.menu.updateActiveName();
      });
    },
  },
  methods: {
    updateMenuState() {
      this.$nextTick(() => {
        if (this.$refs.menu) {
          this.$refs.menu.updateActiveName();
          if (this.menuAccordion) {
            this.$refs.menu.updateOpened();
          }

          // 聚焦当前项
          this.$nextTick(() => {
            const $activeMenu = document.getElementsByClassName(
              "ivu-menu-item ivu-menu-item-active ivu-menu-item-selected"
            );
            if (
              $activeMenu &&
              $activeMenu.length &&
              !isElementInViewport($activeMenu[0])
            ) {
              const activeMenuTop = $activeMenu[0].getBoundingClientRect().top;
              const $menu = this.$refs.menu.$el;
              setTimeout(() => {
                this.$ScrollTop($menu, {
                  to: activeMenuTop,
                  time: 0,
                });
              }, 300);
            }
          });
        }
      });
    },
    updateMenuStateOnCollapse() {
      // 根据当前路由设置菜单openNames
      this.$store.dispatch("admin/db/database", { user: true }).then((db) => {
        const menuList = db.get("userMenuList").value();
        const headerName = getHeaderName(
          this.$route.path,
          menuList,
          this.$route.fullPath
        );
        if (headerName) {
          const menuSider = getMenuSider(menuList, headerName);
          const openNames = getSiderOpenNames(
            this.$route.fullPath,
            menuSider,
            true
          );
          if (openNames.length > 0) {
            this.$store.commit("admin/menu/setOpenNames", openNames);
          }
        }
      });
    },
    handleOpenNameChange(openNames) {
      this.$store.dispatch("admin/db/database", { user: true }).then((db) => {
        const menuList = db.get("userMenuList").value();
        const headerName = window.localStorage.oa_currentMenuPath;
        if (headerName) {
          const menuSider = getMenuSider(menuList, headerName);
          for (let i = 0, item; (item = menuSider[i++]); ) {
            if (item.opened === 1 && openNames.indexOf(item.url) === -1) {
              item.opened = 0;
            } else if (openNames.indexOf(item.url) !== -1) {
              item.opened = 1;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.side-bg {
  /deep/ .i-layout-menu-side {
    background: transparent;
  }
}
.bg-logo {
  width: 220px;
  height: 70px;
}

.bg-logo1 {
  width: 80px;
  height: 70px;
}

.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  color: #1659e2 !important;
  background: #ecf2fe !important;
  z-index: 2 !important;
}

.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  color: #1659e2 !important;
}

.ivu-menu-light.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu)::after {
  content: "";
  display: block;
  width: 2px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  background: #ecf2fe !important;
}

.menu-header {
  img {
    width: 40px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
